import {Assignees} from './Assignees'
import {Development} from './Development'
import {Labels} from './Labels'
import {LabelsSection} from './LabelsSection'
import {Reviewers} from './reviewers/Reviewers'
import {SidebarActions} from './SidebarActions'
import {ReviewersSection} from './reviewers/ReviewersSection'
import {SidebarSection} from './SidebarSection'
import {SidebarActivity} from './activity/SidebarActivity'
import {ActivitySection} from './activity/ActivitySection'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {TeamReviewSummary} from './reviewers/TeamReviewSummary'
import {Participants} from './overview-info/Participants'
import {Deployments} from './Deployments'

export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoContent">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  return (
    <>
      <ActivitySection>
        <SidebarActivity />
      </ActivitySection>

      <ReviewersSection>
        <Reviewers />
      </ReviewersSection>

      <TeamReviewSummary />

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>

      <LabelsSection>
        <Labels />
      </LabelsSection>

      <SidebarSection title="Development">
        <Development />
      </SidebarSection>

      <Deployments />

      <Participants />

      <SidebarActions />
    </>
  )
}
